import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

type StepIndicatorProps = {
  currentStep: number;
};

export default function StepIndicator({ currentStep }: StepIndicatorProps) {
  const { t } = useTranslation();
  const steps = [
    t("stepIndicator.plan"),
    t("stepIndicator.company"),
    t("stepIndicator.payment"),
    t("stepIndicator.done"),
  ];

  return (
    <div className="flex items-center justify-center gap-2 py-8">
      {steps.map((label, i) => {
        const step = i + 1;
        const isActive = step === currentStep;
        const isDone = step < currentStep;

        return (
          <div key={label} className="flex items-center gap-2">
            <div className="flex items-center gap-2">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-all ${
                  isDone
                    ? "bg-accent text-accent-foreground"
                    : isActive
                      ? "bg-accent text-accent-foreground ring-4 ring-accent/20"
                      : "bg-muted text-muted-foreground"
                }`}
              >
                {isDone ? <Check className="h-4 w-4" /> : step}
              </div>
              <span
                className={`hidden text-sm font-medium sm:inline ${
                  isActive ? "text-foreground" : isDone ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && <div className={`mx-2 h-px w-8 sm:w-12 ${isDone ? "bg-accent" : "bg-border"}`} />}
          </div>
        );
      })}
    </div>
  );
}
